var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 58,
    viewBox: "0 0 53 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9483_3562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3636 19.3333V38.6667C43.3636 40.0031 42.2868 41.0833 40.9545 41.0833C39.6223 41.0833 38.5455 40.0031 38.5455 38.6667V19.3333C38.5455 17.9969 39.6223 16.9167 40.9545 16.9167C42.2868 16.9167 43.3636 17.9969 43.3636 19.3333ZM31.3182 0C29.986 0 28.9091 1.08025 28.9091 2.41667V55.5833C28.9091 56.9198 29.986 58 31.3182 58C32.6504 58 33.7273 56.9198 33.7273 55.5833V2.41667C33.7273 1.08025 32.6504 0 31.3182 0ZM50.5909 9.66667C49.2587 9.66667 48.1818 10.7469 48.1818 12.0833V45.9167C48.1818 47.2531 49.2587 48.3333 50.5909 48.3333C51.9231 48.3333 53 47.2531 53 45.9167V12.0833C53 10.7469 51.9231 9.66667 50.5909 9.66667ZM21.6818 9.66667C20.3496 9.66667 19.2727 10.7469 19.2727 12.0833V45.9167C19.2727 47.2531 20.3496 48.3333 21.6818 48.3333C23.014 48.3333 24.0909 47.2531 24.0909 45.9167V12.0833C24.0909 10.7469 23.014 9.66667 21.6818 9.66667ZM12.0455 16.9167C10.7132 16.9167 9.63636 17.9969 9.63636 19.3333V38.6667C9.63636 40.0031 10.7132 41.0833 12.0455 41.0833C13.3777 41.0833 14.4545 40.0031 14.4545 38.6667V19.3333C14.4545 17.9969 13.3777 16.9167 12.0455 16.9167ZM2.40909 21.75C1.07686 21.75 0 22.8303 0 24.1667V33.8333C0 35.1698 1.07686 36.25 2.40909 36.25C3.74132 36.25 4.81818 35.1698 4.81818 33.8333V24.1667C4.81818 22.8303 3.74132 21.75 2.40909 21.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9483_3562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAudio);
export default __webpack_public_path__ + "static/media/white-audio.a8da78f4b583d4fe3b363865e6218afb.svg";
export { ForwardRef as ReactComponent };